import React, { useState, useEffect } from "react";
import "../styles/global.scss";
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import TopView from "./Sections/TopView";
import Work from "./Sections/Work";
import Process from "./Sections/Process";
import "ress";
import Philosophy from "./Sections/Philosophy";
import Other from "./Sections/Other";
import ImageArea from "./Sections/ImageArea";
import { useImagePresenter } from "../components/Image/useImagePresenter";
import topImage from "../../static/top.jpeg";
import styles from "./style.module.scss";
import { motion } from "framer-motion";
import Footer from "../components/Footer";

const Home = () => {
  const { loaded } = useImagePresenter(topImage);
  const [isWaiting, setIsWaiting] = useState(false);

  useEffect(() => setInterval(() => setIsWaiting(true), 3000), []);
  const style = {
    background: "#E79A37",
    borderRadius: 30,
    width: 100,
    height: 100,
    margin: "auto",
  };
  return (
    <Layout>
      <SEO
        title="株式会社ミヤザワ"
        description="長野県上田市を拠点に、金型の設計から製造、プラスチック成形までトータルに生産する会社です。"
      />
      {loaded && isWaiting ? (
        <>
          <TopView />
          <Philosophy />
          <ImageArea />
          <Process />
          <Work />
          <Other />
          <Footer />
        </>
      ) : (
        <div className={styles.loading}>
          <motion.div
            style={style}
            className={styles.center}
            animate={{
              scale: [1, 2, 2, 1, 1],
              rotate: [0, 160, 270, 360, 0],
              borderRadius: ["20%", "50%", "20%", "50%", "20%"],
            }}
            transition={{ duration: 2, repeat: Infinity }}
          />
        </div>
      )}
    </Layout>
  );
};

export default Home;
